export default class Settings {
	public static retrieveEnv(): 'development' | 'staging' | 'production' {
		return this.retrieveByKeyOrEmpty('VITE_ENV') as 'development' | 'staging' | 'production'
	}

	public static retrieveApiUrl(): string {
		return this.retrieveByKeyOrEmpty('VITE_API_BASE_URL')
	}

	public static baseUrl(): string {
		return this.retrieveByKeyOrEmpty('VITE_BASE_URL')
	}

	public static oldWebUrl(): string {
		return this.retrieveByKeyOrEmpty('VITE_OLD_WEB_URL')
	}

	public static isDev(): boolean {
		return this.retrieveEnv() === 'development'
	}

	public static isProd(): boolean {
		return this.retrieveEnv() === 'production'
	}

	public static isStaging(): boolean {
		return this.retrieveEnv() === 'staging'
	}

	public static googleMapsApiId(): string {
		return this.retrieveByKeyOrEmpty('VITE_GOOGLE_MAPS_API_ID')
	}

	public static googleMapsId(): string {
		return this.retrieveByKeyOrEmpty('VITE_GOOGLE_MAPS_ID')
	}

	public static mapboxToken(): string {
		return this.retrieveByKeyOrEmpty('VITE_MAPBOX_TOKEN')
	}

	public static mapboxStylesUrl(): string {
		return this.retrieveByKeyOrEmpty('VITE_MAPBOX_STYLES_URL')
	}

	public static notificationsTimeToBeHidden(): number {
		const hideNotificationAt: string = this.retrieveByKeyOrEmpty(
			'VITE_HIDE_NOTIFICATIONS_AT_MILLISECONDS'
		)
		if (hideNotificationAt) return Number(hideNotificationAt)
		return 5000
	}

	public static androidDownloadLink(): string {
		return this.retrieveByKeyOrEmpty('VITE_APP_ANDROID_LINK')
	}

	public static iosDownloadLink(): string {
		return this.retrieveByKeyOrEmpty('VITE_APP_IOS_LINK')
	}

	public static gtagId(): string {
		return this.retrieveByKeyOrEmpty('VITE_GOOGLE_ANALYTICS_ID')
	}

	public static googleOAuthId(): string {
		return this.retrieveByKeyOrEmpty('VITE_OAUTH_GOOGLE_CLIENT_ID')
	}

	public static defaultTripCoverUrl(): string {
		return this.retrieveByKeyOrEmpty('VITE_DEFAULT_TRIP_COVER_URL')
	}

	public static defaultTripCoverId(): string {
		return this.retrieveByKeyOrEmpty('VITE_DEFAULT_TRIP_COVER_ID')
	}

	public static salesTripPhone(): string {
		return this.retrieveByKeyOrEmpty('VITE_TRIP_SALES_PHONE')
	}

	public static civitatisAffiliate(): string {
		return this.retrieveByKeyOrEmpty('VITE_CIVITATIS_AFFILIATE_ID')
	}

	public static civitatisProviderId(): string {
		return this.retrieveByKeyOrEmpty('VITE_CIVITATIS_PROVIDER_ID')
	}

	public static onboardingMediaUrl(): string {
		return this.retrieveByKeyOrEmpty('VITE_ONBOARDING_MEDIA_BASE_URL')
	}

	private static retrieveByKeyOrEmpty(key: string): string {
		return import.meta.env[key] || ''
	}
}
